module.exports = __webpack_public_path__ + "img/ticket.a9b27804.jpg";